/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const BoxBorder = (props) => {

    return (
        <div className="boxBorder">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 806 682.6" enableBackground="new 0 0 806 682.6" xmlSpace="preserve" preserveAspectRatio="none">
                <path className="boxBorder__path" id={props.id} fill="none" stroke="#FFFFFF" strokeWidth="5" strokeMiterlimit="10" d="M402.7,680.1H13.4c-6,0-10.9-4.9-10.9-10.9V13.4
                    c0-6,4.9-10.9,10.9-10.9h779.3c6,0,10.9,4.9,10.9,10.9v655.9c0,6-4.9,10.9-10.9,10.9L402.7,680.1z" />
            </svg>
        </div>
    );
}

export default BoxBorder;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BoxBorder.jsx